import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  productSelectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  productSelectionHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '16px',
    borderRadius: '0px 4px 0px 0px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  productSelectionContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '24px',
    gap: '24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  productSelectionHeaderTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '36px',
    fontStyle: 'normal',
  },
  productSelectionHeaderDesc: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
  },
  structureTypeTitle: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
  },
  structureTypeContentBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '16px',
  },
  productSelectionButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '16px 24px',
    gap: '15px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  cancelButtonClass: {
    padding: '10px 16px',
    borderColor: theme.evPalette.salt[100],
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
  saveButtonClass: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
  structureTypeContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
  },
  propertyTypeRadio: {
    display: 'flex',
    alignItems: 'center',
    '& >label': { cursor: 'pointer', fontSize: '14px' },
    '& >.myev-MuiIconButton-root': { padding: '9px 0' },
  },
  productsAndDeliveryContentBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '16px',
    padding: '24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
  },
  productsAndDeliveryElement: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '24px',
  },
  productSelectionElementContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '24px',
  },
  productSelectionElementSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
    justifyContent: 'space-between',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      gap: '16px',
    },
  },
  productSelectionElementSwitchContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'fit-content',
    gap: '10px',
    '& .myev-MuiCheckbox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '& .myev-MuiTypography-root': {
      margin: '0 !important',
    },
    '@media (min-width: 640px)': {
      width: '33%',
    },
  },
  elementLabel: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    fontStyle: 'normal',
    margin: 'auto 0 auto 0',
  },
  dropdownBox: {
    width: '100%',
    '&>fieldset': { borderColor: `${theme.evPalette.charcoal[600]} !important` },
    '@media (min-width: 640px)': {
      width: '32%',
    },
  },
  inputTextField: {
    height: '44px',
    '&.select': {
      paddingTop: 0,
      paddingBottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
  },
  measurementInstructionContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '24px',
    gap: '16px',
    '& .myev-MuiCheckbox-root': {
      marginLeft: '-9px',
      paddingTop: '0',
      paddingBottom: '0',
    },
  },
  measurementInstructionHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  measurementInstructionsSelect: {
    flex: 1,
    color: theme.evPalette.charcoal[900],
    height: '44px',
  },
  productsAndDeliveryElementsBottom: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
    '&.hide': {
      display: 'none',
    },
  },
  measurementInstructionCB: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: 'fit-content',
    gap: '8px',
    '&.hide': {
      display: 'none',
    },
  },
  productSelectionMesurementCB: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
    margin: 'auto 0px',
  },
  structureTypeText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    fontStyle: 'normal',
  },
  checkChanges: {
    padding: '0px',
    marginRight: '8px',
  },
  deliveryAllowSubsCheckbox: {
    marginLeft: '-9px',
    height: '42px',
  },
  measurementInstructionDDL: {
    width: '100%',
    '@media (min-width: 640px)': {
      width: '32%',
    },
  },
  structureTypeRadio: {
    padding: 0,
    height: '42px',
    width: '42px',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[200],
    },
  },
}));
